import { createRouter,createWebHistory} from 'vue-router'

import store from '../store'

import Empty from '../layouts/Empty.vue'
import Default from '../layouts/Default.vue'
import UserLayout from '../layouts/UserLayout.vue'
import AdminLayout from '../layouts/Admin.vue'


const routes = [
    {
        path: '/',
        name: 'default',
        component: Default,
        children: [
            {
                path: '',
                name: 'home',
                component: () => import('../views/Home')
            },

            {
                path: '/page/:slug',
                name: 'Page',
                component: () => import('../views/Pages/Page')
            },


            {
                path: '/camine/init',
                name: 'camine.Init',
                meta: { requiresAuth: true, name: 'Camine' },
                component: () => import('../views/Camine/Init')
            },

            {
                path: '/postuniversitare/init',
                name: 'postuniversitare.Init',
                component: () => import('../views/Postuniversitare/Init')
            },

            {
                path: '/adeverinte/init',
                name: 'adeverinte.Init',
                meta: { requiresAuth: true, name: 'Adeverinte' },
                component: () => import('../views/Adeverinte/Init')
            },


            {
                path: '/tax/init',
                name: 'tax.Init',
                meta: { requiresAuth: true, name: 'TaxInit' },
                component: () => import('../views/Tax/Init')
            },
            {
                path: '/payments/return',
                name: 'tax.Return',
                meta: { requiresAuth: true },
                component: () => import('../views/Tax/Return')
            },
            {
                path: '/tax/finish/:id',
                name: 'tax.Finish',
                meta: { requiresAuth: true, name: 'TaxFinish' },
                component: () => import('../views/Tax/Finish')
            },

        ]
    },
    {
        path: '/auth',
        name: 'auth',
        component: Default,
        children: [
            {
                path: '/auth/signin',
                name: 'auth.SignIn',
                meta: { guest: true },
                component: () => import('../views/AuthPages/SignIn')
            },
            {
                path: '/auth/signup',
                name: 'auth.SignUp',
                meta: { guest: true, name: 'Inregistreaza-te' },
                component: () => import('../views/AuthPages/SignUp')
            },
            {
                path: '/auth/signup_info',
                name: 'auth.SignUpInfo',
                meta: { guest: true, name: 'Inregistreaza-te' },
                component: () => import('../views/AuthPages/AuthSignUpInfo')
            },
            {
                path: '/auth/signout',
                name: 'auth.SignOut',
                meta: { requiresAuth: true },
                component: () => import('../views/AuthPages/SignIn')
            },
            {
                path: '/auth/recoverpassword',
                name: 'auth.recoverpassword',
                meta: { guest: true },
                component: () => import('../views/AuthPages/RecoverPassword')
            },
            {
                path: '/auth/reset-password/:token',
                name: 'auth.resetpassword',
                meta: { guest: true },
                component: () => import('../views/AuthPages/ResetPassword')
            }
        ]
    },


    {
        path: '/my',
        name: 'my',
        component: UserLayout,
        children: [
            {
                path: '/my/account',
                name: 'my.Account',
                meta: { requiresAuth: true, name: 'My Account' },
                component: () => import('../views/My/Account')
            },
            {
                path: '/my/password',
                name: 'my.Password',
                meta: { requiresAuth: true, name: 'Change Password' },
                component: () => import('../views/My/MyPassword')
            },
            {
                path: '/my/security',
                name: 'my.Security',
                meta: { requiresAuth: true, name: 'Security' },
                component: () => import('../views/My/MySecurity')
            },
            {
                path: '/my/settings',
                name: 'my.Settings',
                meta: { requiresAuth: true, name: 'Settings' },
                component: () => import('../views/My/MySettings')
            },
            {
                path: '/my/taxpays',
                name: 'my.Taxpays',
                meta: { requiresAuth: true, name: 'Taxpays' },
                component: () => import('../views/My/Taxpays')
            },
            {
                path: '/my/payments',
                name: 'my.Payments',
                meta: { requiresAuth: true, name: 'Payments' },
                component: () => import('../views/My/Payments')
            },
            {
                path: '/my/certificates',
                name: 'my.Certificates',
                meta: { requiresAuth: true, name: 'Certificates' },
                component: () => import('../views/My/Certificates')
            },
        ]
    },

    {
        path: '/adm',
        name: 'admin',
        component: AdminLayout,
        meta: { requiresAuth: true, permission: 'admin' },
        children: [
            {
                path: '/admin',
                name: 'admin.Dashboard',
                component: () => import('../views/Admin/Dashboard')
            },
            {
                path: '/admin/users',
                name: 'admin.Users',
                component: () => import('../views/Admin/Users/Users')
            },
            {
                path: '/admin/user/:id',
                name: 'admin.User',
                component: () => import('../views/Admin/Users/User')
            },


            {
                path: '/admin/usersverify',
                name: 'admin.Usersverify',
                component: () => import('../views/Admin/Users/Usersverify')
            },
            {
                path: '/admin/importemsys',
                name: 'admin.ImportEmsys',
                component: () => import('../views/Admin/Import/ImportEmsys')
            },

            {
                path: '/admin/cstudii',
                name: 'admin.Cstudii',
                component: () => import('../views/Admin/Cstudii/Cstudii')
            },
            {
                path: '/admin/cstudii/:id',
                name: 'admin.Cstudiu',
                component: () => import('../views/Admin/Cstudii/Cstudiu')
            },

            {
                path: '/admin/facultatiumfts',
                name: 'admin.Facultatiumfts',
                component: () => import('../views/Admin/Facultatiumft/Facultatiumfts')
            },
            {
                path: '/admin/facultatiumfts/:id',
                name: 'admin.Facultatiumft',
                component: () => import('../views/Admin/Facultatiumft/Facultatiumft')
            },

            {
                path: '/admin/specializariumfts',
                name: 'admin.Specializariumfts',
                component: () => import('../views/Admin/Specializariumft/Specializariumfts')
            },
            {
                path: '/admin/specializariumft/:id',
                name: 'admin.Specializariumft',
                component: () => import('../views/Admin/Specializariumft/Specializariumft')
            },

            {
                path: '/admin/roles',
                name: 'admin.Roles',
                component: () => import('../views/Admin/Users/Roles')
            },
            {
                path: '/admin/role/:id',
                name: 'admin.Role',
                component: () => import('../views/Admin/Users/Role')
            },


            {
                path: '/admin/global-variables',
                name: 'admin.GlobalVariables',
                component: () => import('../views/Admin/Global/GlobalVariable')
            },


            {
                path: '/admin/sesiunetaxes',
                name: 'admin.SesiuneTaxes',
                component: () => import('../views/Admin/SesiuneTaxe/SesiuneTaxes.vue')
            },
            {
                path: '/admin/sesiunetaxe/:id',
                name: 'admin.SesiuneTaxe',
                component: () => import('../views/Admin/Sesiunetaxe/SesiuneTaxe')
            },



            {
                path: '/admin/taxpays',
                name: 'admin.Taxpays',
                component: () => import('../views/Admin/Taxpays/Taxpays')
            },
            {
                path: '/admin/taxpsy/:id',
                name: 'admin.Taxpay',
                component: () => import('../views/Admin/Taxpays/Taxpay')
            },






            {
                path: '/admin/adeverinte',
                name: 'admin.Certificates',
                component: () => import('../views/Admin/Certificates/Certificates')
            },
            {
                path: '/admin/adeverinte/:id',
                name: 'admin.Certificate',
                component: () => import('../views/Admin/Certificates/Certificate')
            },


        ]
    }

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next)=>{
    window.scrollTo(0, 0)
    if (to.meta && to.meta.requiresAuth) {
        let authenticated = store.getters['auth/isAuthenticated'];

        if (!authenticated) {
            next({ name: 'auth.SignIn' });
        } else {
            if (to.meta.permission) {
                let isAdmin = store.getters['auth/isAdmin'];
                if( !isAdmin ) {
                    if (to.name !== 'home') {
                        next({ name: 'home' });
                    } else {
                        next();
                    }
                    return;
                }
            }
            next();
        }
    } else if (to.meta && to.meta.guest) {
        let authenticated = store.getters['auth/isAuthenticated'];

        if (authenticated) {
            // Previne bucla infinită
            if (to.name !== 'home') {
                next({ name: 'home' });
            } else {
                next();
            }
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
